import React from 'react'
import {Form, Button, Row, Col} from "react-bootstrap";
import Api from "../../../helpers/Api";
import SubmitButton from "../components/SubmitButton";
import Heading from "../../../Components/Heading/Heading";
import DataStore from "../../../helpers/DataStore";

class PostForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            post: {silent:false},
            files: []
        }
    }

    componentDidMount() {
        let {match: {params}} = this.props;
        if (params.id) {
            this.loadData(params.id);
        }
    }

    loadData = (id) => {
        if (id === 'new') {
            return;
        }
        Api.call(`/notifications/${id}`).then(post => {
            this.setState({post});
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        });
    };


    validate = ()=>{
        let {post} = this.state;
        if(!post.title){
            alert("Title is required");
            return false;
        }
        return true;
    };

    submit = (e) => {
        e.preventDefault();
        if(!this.validate()){
            return;
        }
        if (this.state.post.id) {
            this.update();
        } else {
            this.create();
        }
    };

    update = () => {
        this.setState({loading: true});
        Api.call(`/notifications/${this.state.post.id}`, "POST", this.state.post).then(post => {
            this.setState({post: post});
            this.props.history.push('/app/notifications');
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        })
    };
    create = () => {
        this.setState({loading: true});
        let {post, files} = this.state;
        let file = files.thumbnail;

        post.author = DataStore.getUser().id;
        let formData = new FormData();
        formData.append("data", JSON.stringify(post));
        console.log(JSON.stringify(post));
        console.log(JSON.stringify(post));
        if (file) {
            formData.append("files[thumbnail]", file);
        }
        console.log(formData);
        Api.call(`/notifications`, "POST", formData, true).then(post => {
            this.setState({post: post});
            this.props.history.push('/app/notifications');
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        })
    };
    onChange = (key, value) => {
        console.log(key, value);
        let {post} = this.state;
        post[key] = value;
        this.setState({post: post});
    };

    onFileChange = (key, value) => {
        console.log(key, value);
        let {files} = this.state;
        files[key] = value;
        var reader = new FileReader();

        this.setState({files: files});
        let url = reader.readAsDataURL(value);

        reader.onloadend = function (e) {
            this.setState({
                previewUrl: [reader.result]
            });
        }.bind(this);
    };

    render() {
        let {post} = this.state;

        return (
            <div className="dashboard">

                <Heading name="Edit"/>

                <div style={{marginTop: '70px'}}>
                    <Row>
                        <Col md={6}>
                            <Form autoComplete={'off'} onSubmit={this.submit}>
                                <Form.Group controlId="title">
                                    <Form.Label>Title</Form.Label>
                                    <Form.Control type="text" value={post.title}
                                                  onChange={event => this.onChange('title', event.target.value)}
                                                  placeholder="" style={{direction: 'rtl'}}/>
                                </Form.Group>
                                <Form.Group controlId="content">
                                    <Form.Label>Post ID</Form.Label>
                                    <Form.Control type="number" value={post.postId}
                                                  onChange={event => this.onChange('postId', event.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="silent">
                                    <Form.Check type="checkbox" checked={post.silent}
                                                onChange={event => this.onChange('silent', event.target.checked)}
                                                label="Silent Notification"/>
                                </Form.Group>
                                <SubmitButton label={'Submit'} loading={this.state.loading}/>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default PostForm
